import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Link,
  Button,
  TextField,
  InputAdornment,
  List,
  ListItem,
  Tooltip,
} from "@mui/material";
import CreateCohort from "./CreateCohort";
import ToggleButton from "@mui/material/ToggleButton";
import { NavLink } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CohortUserTable from "./CohortTableUser";
import { format } from "date-fns";
import SearchIcon from "@mui/icons-material/Search";
import { getalltaskbyid, getexportretailers, getuserretailers } from "../../pages/assign-task/api";
import { getToken } from "../../utils/utils";
import PaginationComponent from "../../pages/brands/Pagination";
import Export from "../../../src/assests/images/export.svg";

interface RowData {

  id: number;
  pmpmiEntityCodei: string;
  retailerName: string;
  outletName: string;
  outletType: string;
  location: string;
  asm: string;
  distribution: string;
  salesVolume: string;
  user_ids: string

}

interface TaskData {
  task_name: string;
  credit_points: string;
  durations: string;
}

function CohortUser() {
  const navigate = useNavigate();
  const perpagedata = 10;
  const { cohort_id } = useParams();
  const token = getToken();

  const [page, setPage] = useState(1);
  const limit = 10;
  const [selectedDate1, setSelectedDate1] = useState<Date | null>(null);
  const [selectedTime, setSelectedTime] = useState<string | null>(null);

  const [data, setData] = useState<RowData[]>([]);
  const [combineddata, setcombineddata] = useState('');

  const [checkbaledata, setcheckbaledata] = useState([]);
  const location = useLocation();
  const [missingidss, setmissingidss] = useState([]);
    const [maintasknamess, settasknames] = useState([]);
  const [searchlegth, setserchlength] = useState(0);
  const [cohortname, setcohortname] = useState('');
  const [gettaskdata, setgettaskdata] = useState<TaskData | null>(null);
  const [cohorttaskid, setcohorttaskid] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");


  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  useEffect(() => {
    const fetchCohortUsers = async () => {
      setLoading(true);
      try {
        const reqBody = {
          cohort_id: String(cohort_id),
          page: String(page),
          limit: String(limit),
          search: debouncedSearchTerm,
        };
        const response = await getuserretailers(reqBody, token);

        const transformedData = response.data.data.finaluser_tasks.map(
          (item: {
            user_ids: any;
            retailerIds: any;
            pmi_entity_code: string;
            retailer_name: any;
            outletName: any;
            outlet_type: any;
            location_type: any;
          }) => {
            return {
              id: item.retailerIds,
              pmpmiEntityCodei: item.pmi_entity_code,
              retailerName: item.retailer_name,
              outletName: item.outletName,
              outletType: item.outlet_type,
              location: item.location_type,
              user_ids: item.user_ids,
              asm: "xyz",
              distribution: "xyz",
              salesVolume: "xyz",
            };
          }
        );

        setData(transformedData);
        setserchlength(response.data.data.distinctRetailersCount)
        setcohortname(response.data.data.cohortInfo.cohort_name);
        setcohorttaskid(response.data.data.cohortInfo.task_id)
settasknames(response.data.data.cohortInfo.tasknames)
console.log(response.data.data.finaluser_tasks.map((item: { taskNames: any; })=>item.taskNames), "response.data.data.taskNameseeeeeee")
        setcheckbaledata(response.data.data.userdetails)

        setmissingidss(response.data.data.missingidss)

        setcombineddata(response.data.data.cohortInfo.allCombinedData)

      } catch (err) {
        console.error("Error fetching cohort users:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCohortUsers();
  }, [debouncedSearchTerm, cohort_id, token, page, limit]);

  console.log(cohorttaskid, "cohorttaskidcohorttaskid")
  useEffect(() => {
    if (cohorttaskid) { // Ensure cohorttaskid is available before fetching
      const fetchalltaskids = async () => {
        try {
          const reqBody = { task_id: String(cohorttaskid) };
          const response = await getalltaskbyid(reqBody, token);
          const brandDetailsData = response?.data?.data || [];

          console.log(brandDetailsData, "Fetched task data");
          setgettaskdata(brandDetailsData);
        } catch (error) {
          console.error("Error fetching task name:", error);
        }
      };

      fetchalltaskids(); // Call the function inside the block
    }
  }, [cohorttaskid, token]); // Ensure useEffect runs when cohorttaskid or token changes


  const totalPages = Math.ceil(searchlegth / perpagedata);

  // Example handler
  const handleCombinedAssignClick = () => {
    // You can put your logic here
    console.log("Assign button clicked!");

    // Example: Call an API or trigger another function
    // assignTaskToUser(taskId, userId);
  };


  const handleExportClick = async () => {
    try {
      const response = await getexportretailers(String(cohort_id), token, debouncedSearchTerm);

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `cohort_1.xlsx`);
      document.body.appendChild(link);
      link.click();

    } catch (error) {
      console.error("Error exporting CSV:", error);
    }
  };
  const cohortUserPathPattern = /^\/cohort-user(\/\d+)?$/;

  const shouldHideAssignButtons = cohortUserPathPattern.test(location.pathname);
  console.log(combineddata, "combineddatacombineddatacombineddata")
  console.log(checkbaledata, "checkbaledatacheckbaledata222222222")

  const linkStyles = {
    textDecoration: "none",
    fontSize: "14px",
    fontWeight: "600",
    color: "rgba(142, 2, 15, 1)",
  };

  const isCohortUser = location.pathname.startsWith("/cohort-user");

  return (
    <div>
      <Box sx={{ padding: "24px 32px 30px", background: "#fff " }}>
        <Link
          href="/manage-task"
          sx={{
            textDecoration: "none",
            fontSize: "14px",
            fontWeight: "500",
            color: "rgba(105, 106, 107, 1)",
          }}
        >
          Tasks /&nbsp;


          <Link
            component={RouterLink} // ✅ tells MUI Link to render React Router Link
            to={isCohortUser ? "/cohorts-view" : "/manage-tasks"}
            sx={linkStyles}
          >
            {isCohortUser ? "Cohort View Details" : "Assign Task"}
          </Link>


        </Link>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >

          {!shouldHideAssignButtons ? (
            <Box>
              <Typography
                variant="h3"
                sx={{
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "#000",
                  marginTop: "16px",
                }}
              >
                {gettaskdata && gettaskdata.task_name}
              </Typography>
            </Box>
          ) : (
            <Box>
              <Typography
                variant="h3"
                sx={{
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "#000",
                  marginTop: "16px",
                }}
              >
                Cohort View Details
              </Typography>
            </Box>
          )}

          {/* <Box sx={{ display: "flex", marginRight: "20px" }}>
            <Tooltip title="Upload & Check Users" arrow>
              <Button
                sx={{
                  borderRadius: "8px",
                  padding: "10px 16px",
                  color: "#c8172f",
                  textDecoration: "none",
                  border: "1px solid #c8172f",
                  textAlign: "center",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none",
                  width: "200px",
                  background: "#fff",
                  marginRight: "20px",
                }}
              >
                Upload & Check Users
              </Button>
            </Tooltip>
          </Box> */}
        </Box>
        {!shouldHideAssignButtons && (
          <Box sx={{ background: "#F9FBFC", marginTop: "20px" }}>
            <Box sx={{ width: "450px", paddingLeft: "20px" }}>
              <List sx={{ display: "flex" }}>
                <ListItem sx={{ paddingLeft: "0" }}>
                  <label style={{ color: "#494A4B" }} htmlFor="points">
                    Points:
                  </label>
                  <strong id="points">{gettaskdata?.credit_points} Pts</strong>
                </ListItem>
                <ListItem sx={{ paddingLeft: "0" }}>
                  <label htmlFor="duration">Duratissssson:</label>
                  <strong id="duration">{gettaskdata?.durations}</strong>
                </ListItem>
              </List>
            </Box>
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "20px;",

          }}
        >
          <TextField
            required
            placeholder="Search by PMI Entity Code, Outlet Name, Location"
            sx={{
              ".MuiOutlinedInput-root": {
                borderRadius: "12px",
                height: "48px",
                width: "521px",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Button
            variant="contained"
            sx={{
              textTransform: "capitalize",
              backgroundColor: "#fff",
              width: "150px",
              fontSize: "14px",
              fontWeight: "500",
              height: "40px",
              padding: "16px",
              borderRadius: "10px",
              color: "#C8172F",
              border: "1px solid #C8172F",
              boxShadow: "none",
              "&:hover": {},
              "& .MuiButton-endIcon": {
                fontSize: "30px",
                color: "var(--Icon-Colour, #C8172F)",
              },
              "&:before, &:after": {
                border: "none",
              },
            }}
            startIcon={<img src={Export} alt="export"></img>}
            onClick={() => handleExportClick()}
          >
            Export CSV
          </Button>
        </Box>
      </Box>



      <Box>
        <CohortUserTable  maintasknamess={maintasknamess}  missingidss={missingidss} checkbaledata={checkbaledata} searchlegth={searchlegth} page={page} setPage={setPage} cohorttaskid={cohorttaskid} combineddata={combineddata} data={data} cohortname={cohortname} totalPages={totalPages.toString()} selectedDate1={selectedDate1} setSelectedDate1={setSelectedDate1} selectedTime={selectedTime} setSelectedTime={setSelectedTime} />
        <Box>

          {/* <Box>
                <PaginationComponent page={0} limit={0} totalPages={0} setPage={function (page: number): void {
                    throw new Error("Function not implemented.");
                }} />
            </Box> */}
        </Box>
      </Box>
    </div>
  );
}

export default CohortUser;